import React from "react";
import { Box, Button, useTheme, useMediaQuery, Typography } from "@mui/material";
import HomeCardMedia from "./HomeCardMedia";

const LeftContent = ({ data, onReadMore, onEditImage, canEdit = false }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  // Only show content if it's different from the comment
  const shouldShowContent = data?.content && data?.content !== data?.comment;

  return (
    <Box
      sx={{
        width: "100%",
        height: { xs: "auto", sm: "100%" },
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "flex-start",
        gap: { xs: 1.5, sm: 2 },
        p: { xs: 1, sm: 1.5, md: 2 },
        overflow: "hidden", // Prevent outer container from scrolling
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: { xs: "100%", sm: "400px", md: "450px" },
          position: "relative",
          borderRadius: { xs: 1.5, sm: 2 },
          overflow: "hidden",
          boxShadow: { xs: "0 2px 8px rgba(0,0,0,0.08)", sm: "0 4px 12px rgba(0,0,0,0.1)" },
          display: "flex",
          justifyContent: "center",
          flexShrink: 0, // Prevent image from shrinking
        }}
      >
        <HomeCardMedia 
          data={data}
          onEditImage={onEditImage}
          canEdit={canEdit}
        />
      </Box>

      {shouldShowContent && (
        <Box
          sx={{
            width: "100%",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            gap: { xs: 1.5, sm: 2 },
            position: "relative",
            flex: { xs: "0 1 auto", sm: 1 }, // Take remaining space on desktop
            maxHeight: { xs: "40vh", sm: "none" },
            overflow: "auto", // Make this area scrollable
            "&::-webkit-scrollbar": {
              width: { xs: "6px", sm: "8px" },
            },
            "&::-webkit-scrollbar-track": {
              background: "#f1f1f1",
              borderRadius: "4px",
            },
            "&::-webkit-scrollbar-thumb": {
              background: "#888",
              borderRadius: "4px",
              "&:hover": {
                background: "#555",
              },
            },
          }}
        >
          <Box
            sx={{
              width: "100%",
              position: "relative",
              textAlign: "center",
              padding: { xs: "12px 0", sm: "16px 0", md: "20px 0" },
            }}
          >
            <Typography
              variant="body1"
              sx={{
                fontSize: { xs: "0.875rem", sm: "0.9375rem", md: "1rem" },
                lineHeight: { xs: 1.5, sm: 1.6 },
                color: "text.secondary",
                textAlign: "center",
                whiteSpace: "pre-wrap", // Preserve line breaks
                wordWrap: "break-word",
                px: { xs: 0.5, sm: 0 },
              }}
            >
              {data.content}
            </Typography>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default LeftContent;
